<template>
  <v-ons-pull-hook class="pull-hook"
    fixed-content=""
    :height="height"
    threshold-height="-1"
    :max-height="maxHeight"
    :action="localAction"
    @changestate="pullHookState = $event.state"
  >
    <span class="refresh" v-bind:class="{ animating: pullHookState === 'action' }"></span>
  </v-ons-pull-hook>
</template>

<script>
export default {
  props: {
    action: Function,
    height: {
      type: String,
      default: '64px',
    },
    maxHeight: {
      type: String,
      default: '96px',
    },
  },

  data() {
    return {
      pullHookState: 'initial',
    };
  },

  methods: {
    localAction(done) {
      this.action(done);
    },
  },
};
</script>
